<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="item">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.edit_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ item.name }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-row justify="center" align="center">
                        <v-col lg="6" md="8" sm="12" xs="12">
                            <v-form ref="institute_edit" v-on:submit.prevent="submit">
                                <v-text-field v-model="item.code" filled :color="color" label="Código de la institución" :rules="[rules.required]"></v-text-field>
                                <v-text-field v-model="item.name" filled :color="color" label="Nombre de la institución" :rules="[rules.required]"></v-text-field>
                                <v-text-field v-model="item.proof_type" filled :color="color" label="Tipo de comprobante" :rules="[rules.required]"></v-text-field>
                                <v-text-field v-model="item.per_person" type="number" filled :color="color" label="Acuerdo por persona (Institución)" :rules="[rules.required]"></v-text-field>
                                <v-text-field v-model="item.total_allowed" type="number" filled :color="color" label="Personas permitidas por referencia" :rules="[rules.required]"></v-text-field>
                                <v-text-field v-model="item.discount" type="number" filled :color="color" label="Cantidad de descuento" :rules="[rules.required]"></v-text-field>
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col lg="6" md="8" sm="12" xs="12" class="text-right mx-auto">
                            <v-btn @click="cancel" :disabled="loading" text>Cancelar</v-btn>
                            <v-btn type="submit" :loading="loading" color="#008dd4" @click="submit" dark>Actualizar</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import iziToast from 'izitoast'

export default {
    props:['item','dialog','update_url'],
    data: () => ({
        loading:false,
        color:"#000",
        rules:{
            required: v => !!v || 'El campo es requerido',
        },
    }),

    methods:{
        submit:function(){
            if(this.$refs.institute_edit.validate()){
                this.loading = true
                let data = {}
                data.id            = this.item.id
                data.code          = this.item.code
                data.name          = this.item.name
                data.proof_type    = this.item.proof_type
                data.per_person    = this.item.per_person
                data.total_allowed = this.item.total_allowed
                data.discount      = this.item.discount

                axios.post(this.update_url, data).then(response => {
                    this.cancel()
                    this.$parent.getItems()

                    iziToast.success({
                        title:"Correcto",
                        position:"topRight",
                        message:"Instituto modificado correctamente"
                    })

                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })

                this.loading = false
            }
        },

        cancel:function(){
            this.$refs.institute_edit.reset()
            this.$parent.edit_dialog = this.loading = false   
        }
    }
}
</script>